import apiClient from './axios';

/**
 * Contact-related API services
 */
const contactService = {
  /**
   * Submit a contact form
   * @param {Object} formData - The contact form data
   * @param {string} formData.fullName - Contact's full name
   * @param {string} formData.email - Contact's email
   * @param {string} formData.phone_no - Contact's phone number
   * @param {string} formData.firm_name - Contact's firm/company name
   * @param {string} formData.message - Contact message
   * @param {File} formData.documents - Contact's document file (optional)
   * @returns {Promise} - API response promise
   */
  submitContactForm: async (formData) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!formData.fullName?.trim()) throw new Error('Name is required');
    if (!formData.email?.trim() || !emailRegex.test(formData.email)) throw new Error('Valid email is required');
    if (!formData.phone_no?.trim() || !phoneRegex.test(formData.phone_no.replace(/[\s-]/g, ''))) throw new Error('Valid 10-digit phone number is required');
    if (!formData.firm_name?.trim()) throw new Error('Firm name is required');
    if (!formData.message?.trim()) throw new Error('Message is required');

    const data = new FormData();
    data.append('fullName', formData.fullName.trim());
    data.append('email', formData.email.trim());
    data.append('phone_no', formData.phone_no.trim());
    data.append('firm_name', formData.firm_name.trim());
    data.append('message', formData.message.trim());
    
    // Append document file if available
    if (formData.documents) {
      data.append('documents', formData.documents);
    }

    // Use multipart/form-data for file uploads
    return apiClient.post('/api/admin/contact-us', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default contactService;
